<template>
  <div class="dcb-card-newsletter">
    <Card v-bind="card">
      <template #brand>
        <div
          class="dcb-card-newsletter__brand"
          aria-hidden="true"
        >
          <SvgIcon
            :image="telekomLogo"
            class="dcb-card-newsletter__brand-t"
            no-icon-class
          />
          <SvgIcon
            :image="dcbLogo"
            no-icon-class
          />
        </div>
      </template>
    </Card>
  </div>
</template>

<script setup lang="ts">
import { Card } from '@i22team/td-longtail-vue-components';
import type { CardComponentProps } from '@i22team/td-longtail-vue-components';
import SvgIcon from '~/components/svg-icon.vue';
import dcbLogo from '~/assets/images/payment-logos/dcb-payment.svg';
import telekomLogo from '~/assets/images/telekom-logo.svg';

const card: CardComponentProps = {
  heading: {
    tag: 'h2',
    size: 'lg',
    text: 'Melde dich zum Newsletter an, um die kommenden Aktionen nicht zu verpassen',
  },
  imagePosition: 'left',
  image: {
    src: '/content/content-images/dcb/418b59f60ecbae97127b7949827d9af8/keyvisual-gamer-rechts.png',
    srcSm: '/content/content-images/dcb/3e5f3364730f3ea8356641cab272b747/keyvisual-gamer-links.png',
    sizes: 'xs:150vw sm:75vw md:50vw lg:50vw',
  },
  buttons: [
    {
      tag: 'a',
      isExternal: true,
      primary: true,
      href: 'https://zeph-vorteile.de/telekom/#newsletter',
      label: 'Zum Newsletter anmelden',
    },
  ],
};
</script>

<style lang="scss" scoped>
@use 'assets/base' as *;

.dcb-card-newsletter {
  margin-bottom: $grid-base * 3;

  .card {
    --card-bg-color: #fff;
    --card-container-justify: center;
    --card-container-content-flex: 0;
    --card-image-background-object-position: 50%;

    @include mq($mq-sm) {
      --card-image-padding: 0;
    }
    @include mq($mq-md) {
      --card-image-background-object-position: 30%;
    }

    :deep(.card__image-container) {
      @include mq($mq-sm) {
        width: calc(100% + 20px);
        text-align: right;
      }
    }

    :deep(.card__image) {
      height: 400px;
      @include mq($mq-sm) {
        height: 500px;
      }
    }

    :deep(.card__background) {
      background: linear-gradient(to bottom right, #c1abe9, #b59fdf);
      @include mq(false, $mq-sm - 1) {
        bottom: auto;
        height: 400px;
      }

      @include mq($mq-sm) {
        right: 50%;
      }
    }
  }

  &__brand {
    color: #fff;
    display: flex;
    gap: $grid-base;

    > svg {
      height: 40px;
    }

    &-t {
      padding: 6px;
      background-color: #fff;
    }
  }
}
</style>
